// extracted by mini-css-extract-plugin
module.exports = {"readmore":"az_JJb","note":"az_KJb","superSku":"az_LJb"};